// language.ts

export interface Language {
  langName: string;
  langCode: string;
  countryCode: string;
}

export const languages: Language[] = [
  { langName: "Afrikaans", langCode: "af", countryCode: "za" },
  { langName: "Albanian", langCode: "sq", countryCode: "al" },
  { langName: "Amharic", langCode: "am", countryCode: "et" },
  { langName: "Arabic", langCode: "ar", countryCode: "sa" },
  { langName: "Armenian", langCode: "hy", countryCode: "am" },
  { langName: "Assamese", langCode: "as", countryCode: "in" },
  { langName: "Aymara", langCode: "ay", countryCode: "bo" },
  { langName: "Azerbaijani", langCode: "az", countryCode: "az" },
  { langName: "Bambara", langCode: "bm", countryCode: "ml" },
  { langName: "Basque", langCode: "eu", countryCode: "es" },
  { langName: "Belarusian", langCode: "be", countryCode: "by" },
  { langName: "Bengali (Bangladesh)", langCode: "bn", countryCode: "bd" },
  { langName: "Bengali (India)", langCode: "bn", countryCode: "in" },
  { langName: "Bhojpuri", langCode: "bho", countryCode: "in" },
  { langName: "Bosnian", langCode: "bs", countryCode: "ba" },
  { langName: "Bulgarian", langCode: "bg", countryCode: "bg" },
  { langName: "Burmese (Myanmar)", langCode: "my", countryCode: "mm" },
  { langName: "Catalan", langCode: "ca", countryCode: "es" },
  { langName: "Cebuano", langCode: "ceb", countryCode: "ph" },
  { langName: "Chinese Cantonese", langCode: "yue", countryCode: "hk" },
  { langName: "Chinese Mandarin (Simplified)", langCode: "zh-CN", countryCode: "cn" },
  { langName: "Chinese Mandarin (Traditional)", langCode: "zh-TW", countryCode: "tw" },
  { langName: "Corsican", langCode: "co", countryCode: "fr" },
  { langName: "Croatian", langCode: "hr", countryCode: "hr" },
  { langName: "Czech", langCode: "cs", countryCode: "cz" },
  { langName: "Danish", langCode: "da", countryCode: "dk" },
  { langName: "Dhivehi", langCode: "dv", countryCode: "mv" },
  { langName: "Dogri", langCode: "doi", countryCode: "in" },
  { langName: "Dutch (Belgium)", langCode: "nl", countryCode: "be" },
  { langName: "Dutch (Netherlands)", langCode: "nl", countryCode: "nl" },
  { langName: "English", langCode: "en", countryCode: "us" },
  { langName: "Esperanto", langCode: "eo", countryCode: "pl" },
  { langName: "Estonian", langCode: "et", countryCode: "ee" },
  { langName: "Ewe", langCode: "ee", countryCode: "gh" },
  { langName: "Filipino (Philippines)", langCode: "fil", countryCode: "ph" },
  { langName: "Finnish", langCode: "fi", countryCode: "fi" },
  { langName: "French", langCode: "fr", countryCode: "fr" },
  { langName: "Frisian", langCode: "fy", countryCode: "nl" },
  { langName: "Galician", langCode: "gl", countryCode: "es" },
  { langName: "Georgian", langCode: "ka", countryCode: "ge" },
  { langName: "German", langCode: "de", countryCode: "de" },
  { langName: "Greek", langCode: "el", countryCode: "gr" },
  { langName: "Guarani", langCode: "gn", countryCode: "py" },
  { langName: "Gujarati", langCode: "gu", countryCode: "in" },
  { langName: "Haitian Creole", langCode: "ht", countryCode: "ht" },
  { langName: "Hausa", langCode: "ha", countryCode: "ng" },
  { langName: "Hawaiian", langCode: "haw", countryCode: "us" },
  { langName: "Hebrew", langCode: "he", countryCode: "il" },
  { langName: "Hindi", langCode: "hi", countryCode: "in" },
  { langName: "Hmong", langCode: "hmn", countryCode: "us" },
  { langName: "Hungarian", langCode: "hu", countryCode: "hu" },
  { langName: "Icelandic", langCode: "is", countryCode: "is" },
  { langName: "Igbo", langCode: "ig", countryCode: "ng" },
  { langName: "Ilocano", langCode: "ilo", countryCode: "ph" },
  { langName: "Indonesian", langCode: "id", countryCode: "id" },
  { langName: "Irish", langCode: "ga", countryCode: "ie" },
  { langName: "Italian", langCode: "it", countryCode: "it" },
  { langName: "Japanese", langCode: "ja", countryCode: "jp" },
  { langName: "Javanese", langCode: "jv", countryCode: "id" },
  { langName: "Kannada", langCode: "kn", countryCode: "in" },
  { langName: "Kazakh", langCode: "kk", countryCode: "kz" },
  { langName: "Khmer", langCode: "km", countryCode: "kh" },
  { langName: "Kinyarwanda", langCode: "rw", countryCode: "rw" },
  { langName: "Konkani", langCode: "gom", countryCode: "in" },
  { langName: "Korean", langCode: "ko", countryCode: "kr" },
  { langName: "Krio", langCode: "kri", countryCode: "sl" },
  { langName: "Kurdish", langCode: "ku", countryCode: "iq" },
  { langName: "Kurdish (Sorani)", langCode: "ckb", countryCode: "iq" },
  { langName: "Kyrgyz", langCode: "ky", countryCode: "kg" },
  { langName: "Lao", langCode: "lo", countryCode: "la" },
  { langName: "Latin", langCode: "la", countryCode: "va" },
  { langName: "Latvian", langCode: "lv", countryCode: "lv" },
  { langName: "Lingala", langCode: "ln", countryCode: "cg" },
  { langName: "Lithuanian", langCode: "lt", countryCode: "lt" },
  { langName: "Luganda", langCode: "lg", countryCode: "ug" },
  { langName: "Luxembourgish", langCode: "lb", countryCode: "lu" },
  { langName: "Macedonian", langCode: "mk", countryCode: "mk" },
  { langName: "Maithili", langCode: "mai", countryCode: "in" },
  { langName: "Malagasy", langCode: "mg", countryCode: "mg" },
  { langName: "Malay", langCode: "ms", countryCode: "my" },
  { langName: "Malayalam", langCode: "ml", countryCode: "in" },
  { langName: "Maltese", langCode: "mt", countryCode: "mt" },
  { langName: "Maori", langCode: "mi", countryCode: "nz" },
  { langName: "Marathi", langCode: "mr", countryCode: "in" },
  { langName: "Meiteilon (Manipuri)", langCode: "mni-Mtei", countryCode: "in" },
  { langName: "Mizo", langCode: "lus", countryCode: "in" },
  { langName: "Mongolian", langCode: "mn", countryCode: "mn" },
  { langName: "Nepali", langCode: "ne", countryCode: "np" },
  { langName: "Norwegian", langCode: "no", countryCode: "no" },
  { langName: "Nyanja (Chichewa)", langCode: "ny", countryCode: "mw" },
  { langName: "Odia (Oriya)", langCode: "or", countryCode: "in" },
  { langName: "Oromo", langCode: "om", countryCode: "et" },
  { langName: "Pashto (Afghanistan)", langCode: "ps", countryCode: "af" },
  { langName: "Persian", langCode: "fa", countryCode: "ir" },
  { langName: "Polish", langCode: "pl", countryCode: "pl" },
  { langName: "Portuguese (Brazil)", langCode: "pt", countryCode: "br" },
  { langName: "Portuguese (Portugal)", langCode: "pt", countryCode: "pt" },
  { langName: "Punjabi", langCode: "pa", countryCode: "in" },
  { langName: "Quechua", langCode: "qu", countryCode: "pe" },
  { langName: "Romanian", langCode: "ro", countryCode: "ro" },
  { langName: "Russian", langCode: "ru", countryCode: "ru" },
  { langName: "Samoan", langCode: "sm", countryCode: "ws" },
  { langName: "Sanskrit", langCode: "sa", countryCode: "in" },
  { langName: "Scots Gaelic", langCode: "gd", countryCode: "gb" },
  { langName: "Sepedi", langCode: "nso", countryCode: "za" },
  { langName: "Serbian", langCode: "sr", countryCode: "rs" },
  { langName: "Sesotho", langCode: "st", countryCode: "ls" },
  { langName: "Shona", langCode: "sn", countryCode: "zw" },
  { langName: "Sindhi", langCode: "sd", countryCode: "pk" },
  { langName: "Sinhala (SriLanka)", langCode: "si", countryCode: "lk" },
  { langName: "Slovak", langCode: "sk", countryCode: "sk" },
  { langName: "Slovenian", langCode: "sl", countryCode: "si" },
  { langName: "Somali", langCode: "so", countryCode: "so" },
  { langName: "Spanish", langCode: "es", countryCode: "es" },
  { langName: "Sundanese", langCode: "su", countryCode: "id" },
  { langName: "Swahili (Kenya)", langCode: "sw", countryCode: "ke" },
  { langName: "Swahili (Tanzania)", langCode: "sw", countryCode: "tz" },
  { langName: "Swedish", langCode: "sv", countryCode: "se" },
  { langName: "Tagalog", langCode: "tl", countryCode: "ph" },
  { langName: "Tajik", langCode: "tg", countryCode: "tj" },
  { langName: "Tamil", langCode: "ta", countryCode: "in" },
  { langName: "Tatar", langCode: "tt", countryCode: "ru" },
  { langName: "Telugu", langCode: "te", countryCode: "in" },
  { langName: "Thai", langCode: "th", countryCode: "th" },
  { langName: "Tigrinya", langCode: "ti", countryCode: "er" },
  { langName: "Tsonga", langCode: "ts", countryCode: "za" },
  { langName: "Turkish", langCode: "tr", countryCode: "tr" },
  { langName: "Turkmen", langCode: "tk", countryCode: "tm" },
  { langName: "Twi (Akan)", langCode: "ak", countryCode: "gh" },
  { langName: "Ukrainian", langCode: "uk", countryCode: "ua" },
  { langName: "Urdu (India)", langCode: "ur", countryCode: "in" },
  { langName: "Urdu (Pakistan)", langCode: "ur", countryCode: "pk" },
  { langName: "Uyghur", langCode: "ug", countryCode: "cn" },
  { langName: "Uzbek", langCode: "uz", countryCode: "uz" },
  { langName: "Vietnamese", langCode: "vi", countryCode: "vn" },
  { langName: "Welsh", langCode: "cy", countryCode: "gb" },
  { langName: "Xhosa", langCode: "xh", countryCode: "za" },
  { langName: "Yiddish", langCode: "yi", countryCode: "il" },
  { langName: "Yoruba", langCode: "yo", countryCode: "ng" },
  { langName: "Zulu", langCode: "zu", countryCode: "za" },
];

export const unsupportedCloudTts: string[] = [
  "af", // Afrikaans
  "am", // Amharic
  "as", // Assamese
  "ay", // Aymara
  "az", // Azerbaijani
  "bm", // Bambara
  "be", // Belarusian
  "bho", // Bhojpuri
  "bs", // Bosnian
  "ceb", // Cebuano
  "co", // Corsican
  "dv", // Dhivehi
  "doi", // Dogri
  "eo", // Esperanto
  "ee", // Ewe
  "fy", // Frisian
  "gn", // Guarani
  "ht", // Haitian Creole
  "ha", // Hausa
  "haw", // Hawaiian
  "hmn", // Hmong
  "ig", // Igbo
  "ilo", // Ilocano
  "rw", // Kinyarwanda
  "gom", // Konkani
  "kri", // Krio
  "ku", // Kurdish
  "ckb", // Kurdish (Sorani)
  "ky", // Kyrgyz
  "la", // Latin
  "ln", // Lingala
  "lg", // Luganda
  "lb", // Luxembourgish
  "mai", // Maithili
  "mg", // Malagasy
  "mt", // Maltese
  "mi", // Maori
  "mni-Mtei", // Meiteilon (Manipuri)
  "lus", // Mizo
  "mn", // Mongolian
  "ny", // Nyanja (Chichewa)
  "or", // Odia (Oriya)
  "om", // Oromo
  "qu", // Quechua
  "sm", // Samoan
  "sa", // Sanskrit
  "gd", // Scots Gaelic
  "nso", // Sepedi
  "st", // Sesotho
  "sn", // Shona
  "sd", // Sindhi
  "so", // Somali
  "tg", // Tajik
  "tt", // Tatar
  "ti", // Tigrinya
  "ts", // Tsonga
  "tk", // Turkmen
  "ak", // Twi (Akan)
  "ug", // Uyghur
  "xh", // Xhosa
  "yi", // Yiddish
  "yo", // Yoruba
  "zu", // Zulu
];

export const unsupportedCloudStt: string[] = [
  "ay", // Aymara
  "bm", // Bambara
  "be", // Belarusian
  "bho", // Bhojpuri
  "ceb", // Cebuano
  "co", // Corsican
  "dv", // Dhivehi
  "doi", // Dogri
  "eo", // Esperanto
  "ee", // Ewe
  "fy", // Frisian
  "gn", // Guarani
  "haw", // Hawaiian
  "hmn", // Hmong
  "ilo", // Ilocano
  "gom", // Konkani
  "kri", // Krio
  "ku", // Kurdish
  "la", // Latin
  "lb", // Luxembourgish
  "mai", // Maithili
  "mi", // Maori
  "mni-Mtei", // Meiteilon (Manipuri)
  "lus", // Mizo
  "ny", // Nyanja (Chichewa)
  "or", // Odia (Oriya)
  "om", // Oromo
  "qu", // Quechua
  "sa", // Sanskrit
  "gd", // Scots Gaelic
  "nso", // Sepedi
  "sd", // Sindhi
  "tg", // Tajik
  "ti", // Tigrinya
  "tk", // Turkmen
  "yi", // Yiddish
];

export const languageCodeMappings: {
  translation: { [key: string]: string };
  tts: { [key: string]: string };
  stt: { [key: string]: string };
} = {
  translation: {
    "zh-CN": "zh-CN", // Mandarin (Simplified)
    "zh-TW": "zh-TW", // Mandarin (Traditional)
    "yue": "yue",     // Cantonese
  },
  tts: {
    "zh-CN": "zh-CN",     // Mandarin (Simplified)
    "zh-TW": "zh-TW",     // Mandarin (Traditional)
    "yue": "yue-HK",      // Cantonese (Hong Kong)
  },
  stt: {
    "zh-CN": "cmn-Hans-CN", // Mandarin (Simplified, China)
    "zh-TW": "cmn-Hant-TW", // Mandarin (Traditional, Taiwan)
    "yue": "yue-Hant-HK",   // Cantonese (Hong Kong)
  },
};

/** Circle-flags URL for language picker (non-audio surfaces). Yiddish: no single flag — use IL as conventional association. */
export function getLanguageFlagSrc(lang: { langCode: string; countryCode: string }): string {
  if (lang.langCode === "yi") {
    return "https://hatscripts.github.io/circle-flags/flags/il.svg";
  }
  return `https://hatscripts.github.io/circle-flags/flags/${lang.countryCode}.svg`;
}